import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'planejamento-peca');

const planejamentoPecaActions = {
  ...genericActions(basePath),
  listarFiltrado: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  pesquisar: { method: 'GET', url: `${basePath}` },
  buscar: { method: 'GET', url: `${basePath}/{id}` },
  removerArquivo: { method: 'DELETE', url: `${basePath}/arquivo?arquivo={arquivo}` },
  getThumb: { method: 'GET', url: `${basePath}/thumb` },
  listaLog: { method: 'GET', url: `${basePath}/log-download-catalogo` },
};

export default resource => resource(`${basePath}`, {}, planejamentoPecaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-peca.js